import React from "react";

import './CallUsButton.css';

const CallUsButton = props => {
    const cellphoneNumber = "8884743195";
    const handleButtonClick = () => {
        window.location.href = `tel:${cellphoneNumber}`;
      };
    return(
   
        <button className="call-us-button" onClick={handleButtonClick} style={{fontSize: '1.1rem', color : '#f25116', fontWeight: '700'}}>
           {props.phonenumber}
        </button>

    );
};

export default CallUsButton;